"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _modal = _interopRequireDefault(require("../common/modal"));

// SPDX-License-Identifier: MIT
// Copyright contributors to the kepler.gl project
var ModalDialogFactory = function ModalDialogFactory() {
  return _modal["default"];
};

var _default = ModalDialogFactory;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tb2RhbHMvbW9kYWwtZGlhbG9nLnRzeCJdLCJuYW1lcyI6WyJNb2RhbERpYWxvZ0ZhY3RvcnkiLCJNb2RhbCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBR0E7O0FBSEE7QUFDQTtBQUlBLElBQU1BLGtCQUFrQixHQUFHLFNBQXJCQSxrQkFBcUI7QUFBQSxTQUFNQyxpQkFBTjtBQUFBLENBQTNCOztlQUVlRCxrQiIsInNvdXJjZXNDb250ZW50IjpbIi8vIFNQRFgtTGljZW5zZS1JZGVudGlmaWVyOiBNSVRcbi8vIENvcHlyaWdodCBjb250cmlidXRvcnMgdG8gdGhlIGtlcGxlci5nbCBwcm9qZWN0XG5cbmltcG9ydCBNb2RhbCBmcm9tICcuLi9jb21tb24vbW9kYWwnO1xuXG5jb25zdCBNb2RhbERpYWxvZ0ZhY3RvcnkgPSAoKSA9PiBNb2RhbDtcblxuZXhwb3J0IGRlZmF1bHQgTW9kYWxEaWFsb2dGYWN0b3J5O1xuIl19